module.exports = __webpack_public_path__ + "static/media/zoomQuartier_Atmospheres.9eab735c.webp";